module.exports = __webpack_public_path__ + "static/media/mastercard.67ade7d8.svg";